const layout = {
  topbarHeight: "60px",
  sidebarWidth: "100px",
};

export default layout;
